export enum ChapterPropTabs {
	GENERAL = 'General',
	LOCALIZATION = 'Localization',
}

export const ChapterTabsConfig: ChapterPropTabs[] = [
	ChapterPropTabs.GENERAL,
	ChapterPropTabs.LOCALIZATION,
];
